import { useCallback } from 'react';
import styled from 'styled-components';
import { EngineeringAdminWrapper, EngineeringButtonWrapper } from '../shared.tsx';
import { showDeleteHouseholdDialog } from './delete_household_dialog.tsx';

export const EngineeringManageHouseholdsPage = () => {
  const onDeleteHousehold = useCallback(async () => {
    await showDeleteHouseholdDialog({});
  }, []);
  return (
    <EngineeringAdminWrapper title={'Manage Households'}>
      <OuterWrapper>
        <EngineeringButtonWrapper onClick={onDeleteHousehold}>Delete Household</EngineeringButtonWrapper>
      </OuterWrapper>
    </EngineeringAdminWrapper>
  );
};

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding-left: 20px;
`;
